
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../../../withItemCache/WithItemCache';
import { cancelProgressItems } from '../../../../operations/progress/cancelProgressItems';
import { makeObject } from '../../../../utilities/objects';
import { Action } from '../../../action/Action';
import { getOverallSimpleProgressBreakdown } from '../../../../operations/progress';

export interface ICancelProgressActionProps {
  itemKeys: string[];
}

/**
 * Item cache action which cancels a specified set of progress items.
 * This action should only be available when the operation backing an item
 * is in a running state and supports cancellation.
 * Executing this action will invoke the registered operation handler for the progress item type in question.
 */
export class CancelProgressAction extends React.PureComponent<ICancelProgressActionProps> {
  public render(): JSX.Element {
    const {
      itemKeys
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache, dispatch }: IItemCacheStateProps) => {
          const eligibleItemKeys = itemKeys.filter((itemKey: string) => {
            const { phase } = getOverallSimpleProgressBreakdown(itemCache, { itemKey });

            return phase === 'started';
          });

          const onExecute = async () => {
            dispatch(cancelProgressItems({
              items: makeObject(eligibleItemKeys, () => ({}))
            }));
          };

          return (
            <Action onExecute={ onExecute } isAvailable={ eligibleItemKeys.length > 0 } />
          );
        } }
      </WithItemCache>
    );
  }
}
